export const FETCH_TOP_STUDENT_SCORES = 'FETCH_TOP_STUDENT_SCORES';
